import {
    editorUpsellLabelWithSuggestions,
    settingsDialogUpsellString,
    editorUpsellLabelWithOneSuggestion,
} from './EditorUpsell.locstring.json';
import loc, { format } from 'owa-localize';

export function getUpsellString(premimumFlagsFound: number | undefined): string {
    if (premimumFlagsFound) {
        if (premimumFlagsFound === 1) {
            return loc(editorUpsellLabelWithOneSuggestion);
        } else if (premimumFlagsFound > 1) {
            return format(loc(editorUpsellLabelWithSuggestions), premimumFlagsFound.toString());
        }
    }

    return loc(settingsDialogUpsellString);
}
